import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { ErrorState } from './textareaOptions';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextareaComponent implements ControlValueAccessor, OnInit {
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() minHeight: number = 60;
  @Input() isRequired = false;
  @Input() isError: boolean = false;
  @Input() errorState: ErrorState = ErrorState.default;
  @Input() errorMessage: string;
  @Input() value: string = '';
  @Output() valueChanged: EventEmitter<string> = new EventEmitter();
  fullWidth = false;
  isDisabled: boolean = false;

  onChange: any = (value: string) => {
  }
  onTouch: any = () => {
  }

  get _value(): string {
    return this.value;
  }

  set _value(v: string) {
    if (v !== this.value) {
      this.value = v;
      this.change(this.value);
    }
  }
  get invalid(): boolean {
    if (this.isError) {
      return this.isError;
    }
    if (this.ngControl)
      return this.ngControl ? this.ngControl.invalid : false;
  }

  get showError(): boolean {
    switch (this.errorState) {
      case ErrorState.default: {
        return this.invalid;
      }
      case ErrorState.focusOut: {
        if (!this.ngControl) {
          return false;
        }
        const { dirty, touched } = this.ngControl;
        return this.invalid ? dirty || touched : false;
      }
    }
  }

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private changeDetectorRef: ChangeDetectorRef) {
    this.ngControl && (this.ngControl.valueAccessor = this);
  }

  ngOnInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  writeValue(value: string): void {
    if (!value) {
      return;
    }
    this.value = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: () => {}): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  change(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouch(value);
  }
  valueChangeHandler(value: string) {
    this.value = value;
    this.onChange(this.value);
    this.valueChanged.emit(this.value);
  }
}

